var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightningBoltIcon = function SvgLightningBoltIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m4.464 1.5-.8 6h4.894a.748.748 0 0 1 .728.932L8.567 11.3l3.578-5.303H7.558a.752.752 0 0 1-.7-1.019L8.21 1.5zm-1.456-.415A1.25 1.25 0 0 1 4.245 0h4.331c.879 0 1.485.885 1.166 1.704L8.655 4.5h3.962a1.25 1.25 0 0 1 1.038 1.95L7.43 15.67a.75.75 0 0 1-1.35-.6L7.595 9H3.376a1.248 1.248 0 0 1-1.234-1.415z"
  })));
};
export default SvgLightningBoltIcon;